(() => {
  const q = (sel, root = document) => root.querySelector(sel);
  const qa = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  function openSizeGuide(event) {
    const trigger = event.target.closest('[data-memiman-open-size]');
    if (!trigger) return;
    event.preventDefault();

    const details = q('[data-memiman-size-accordion]');
    if (!details) return;

    qa('.memiman-accordion').forEach((item) => {
      if (item !== details) item.open = false;
    });

    details.open = true;
    window.requestAnimationFrame(() => {
      details.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function initNestedSizeGuides() {
    qa('.memiman-size-subguide').forEach((item) => {
      if (item.dataset.memimanNestedReady === 'true') return;
      item.dataset.memimanNestedReady = 'true';
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        const container = item.closest('.memiman-size-guides__nested');
        if (!container) return;
        qa('.memiman-size-subguide', container).forEach((sibling) => {
          if (sibling !== item) sibling.open = false;
        });
      });
    });
  }

  function initSwatchNames(productInfo) {
    qa('.product-form__input--swatch', productInfo).forEach((fieldset) => {
      if (fieldset.dataset.memimanSwatchReady === 'true') return;
      fieldset.dataset.memimanSwatchReady = 'true';

      const selectedValue = q('[data-selected-value]', fieldset);
      const output = document.createElement('div');
      output.className = 'memiman-swatch-name';
      output.setAttribute('aria-live', 'polite');
      fieldset.appendChild(output);

      const sync = () => {
        const checked = q('input[type="radio"]:checked', fieldset);
        const value = selectedValue?.textContent?.trim() || checked?.value || '';
        output.textContent = value;
      };

      sync();
      fieldset.addEventListener('change', () => requestAnimationFrame(sync));

      if (selectedValue) {
        new MutationObserver(sync).observe(selectedValue, {
          childList: true,
          characterData: true,
          subtree: true,
        });
      }
    });
  }

  function initProductHelpers() {
    const productInfo = q('product-info[id^="MainProduct-"]');
    if (!productInfo) return;

    const mainButton = q('.product-form__submit', productInfo);
    const delivery = q('[data-memiman-delivery]', productInfo);
    const mainPrice = q('[id^="price-"]', productInfo);
    const sticky = q('[data-memiman-mobile-sticky]');
    const stickyPrice = q('[data-memiman-sticky-price]');
    const stickyButton = q('[data-memiman-sticky-add]');

    initSwatchNames(productInfo);
    initNestedSizeGuides();

    const syncAvailability = () => {
      if (!mainButton) return;
      const disabled = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';
      if (delivery) delivery.hidden = disabled;
      if (stickyButton) {
        stickyButton.disabled = disabled;
        const label = q('span', mainButton)?.textContent?.trim() || mainButton.textContent.trim();
        q('span', stickyButton).textContent = label || 'A\u00F1adir';
      }
    };

    const syncPrice = () => {
      if (!mainPrice || !stickyPrice) return;
      const sale = q('.price__sale .price-item--sale', mainPrice);
      const regular = q('.price__regular .price-item--regular', mainPrice);
      const visiblePrice = sale || regular || q('.price-item', mainPrice);
      if (visiblePrice) stickyPrice.textContent = visiblePrice.textContent.trim();
    };

    syncAvailability();
    syncPrice();

    if (mainButton) {
      new MutationObserver(syncAvailability).observe(mainButton, {
        attributes: true,
        childList: true,
        subtree: true,
      });
    }

    if (mainPrice) {
      new MutationObserver(syncPrice).observe(mainPrice, { childList: true, subtree: true });
    }

    const variantSelects = q('variant-selects', productInfo);
    if (variantSelects) {
      new MutationObserver(() => initSwatchNames(productInfo)).observe(variantSelects, {
        childList: true,
        subtree: true,
      });
    }

    if (stickyButton && mainButton) {
      stickyButton.addEventListener('click', () => mainButton.click());
    }

    if (sticky && mainButton && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        ([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting),
        { threshold: 0.05 }
      );
      io.observe(mainButton);
    }
  }

  document.addEventListener('click', openSizeGuide);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductHelpers, { once: true });
  } else {
    initProductHelpers();
  }
})();